import { ZodError } from 'zod';
import { logError } from '../../../services/errorReporting';

export const logSchemaMismatchError = (error: ZodError, message: string) =>
  logError(new Error(message, { cause: error }), {
    schemaDetails: error.format(),
  });
